import { render, staticRenderFns } from "./ReceiveEdit.vue?vue&type=template&id=1302bd7a&"
import script from "./ReceiveEdit.vue?vue&type=script&lang=js&"
export * from "./ReceiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports